<template>
    <div class="daigou-order-list">
        <div class="container">
            <div class="status-list">
                <div
                    class="status-item"
                    v-for="v in status_list"
                    :key="v.key"
                    :class="{ active: form_data.status == v.key }"
                    @click="change_status(v.key)"
                >
                    {{ v.name }}
                </div>
            </div>

            <template v-if="order_list.length">
                <div class="list">
                    <div class="th">
                        <div class="info">面料信息</div>
                        <div class="qty">代购数量</div>
                        <div class="price">应付金额</div>
                        <div class="status">状态</div>
                        <div class="action">操作</div>
                    </div>
                    <div class="item td" v-for="(v, k) in order_list" :key="k">
                        <div class="title-row">
                            <span>订单号：{{ v.order_no }}</span>
                            <span class="create-time">{{ v.create_time }}</span>
                            <div class="chat-entry" @click="showChat(v)">
                                <img src="../../assets/images/procurement/ico_chat.png" style="width: 18px; height: 18px" />
                                <span>联系采购</span>
                                <span class="unread-badge" v-if="unreadMap[v.uuid] > 0">{{ unreadMap[v.uuid] > 99 ? '99+' : unreadMap[v.uuid] }}</span>
                            </div>
                        </div>
                        <div class="content">
                            <div class="info">
                                <img :src="v.material_image | default_img" class="image" alt="" />
                                <div class="info-text">
                                    <div class="name">{{ v.material_name }}</div>
                                    <div class="code">编号：{{ v.material_code }}</div>
                                    <div class="type">{{ v.material_type_name }}</div>
                                </div>
                            </div>
                            <div class="qty">
                                <span>{{ v.quantity }}{{ v.unit }}</span>
                                <Poptip v-if="colorDetail(v).length" trigger="hover" placement="bottom">
                                    <span class="detail-link">明细</span>
                                    <template #content>
                                        <table class="color-table">
                                            <thead>
                                                <tr><th>代购颜色</th><th>数量</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(c, ci) in colorDetail(v)" :key="`color-${ci}`">
                                                    <td class="c-name">
                                                        <img :src="c.image | default_img" alt="" class="c-img" />{{ c.name || '-' }}
                                                    </td>
                                                    <td>{{ c.send }}{{ v.unit }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                </Poptip>
                            </div>
                            <div class="price">
                                <template v-if="Number(v.total_money) > 0">￥{{ Number(v.total_money).toFixed(2) }}</template>
                                <template v-else>待确认</template>
                            </div>
                            <div class="status" :class="'status-' + v.status">{{ v.status_name }}</div>
                            <div class="action">
                                <!-- 付款不参与订单流转：只要后台已设置金额且未付款即可支付 -->
                                <div class="btn btn-pay" v-if="v.pay_status != 1 && Number(v.total_money) > 0" @click="onPay(v)">在线支付</div>
                                <div class="btn btn-cancel" v-if="v.status == 0" @click="onCancel(v)">取消订单</div>
                                <div class="btn-text" @click="showChat(v)">联系采购</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Page
                    :current="page"
                    :page-size="size"
                    :total="total"
                    @on-change="changePage"
                    show-total
                    style="margin-top: 20px"
                    show-sizer
                    @on-page-size-change="changeSize"
                    :page-size-opts="[5, 10, 20]"
                ></Page>
            </template>
            <template v-else>
                <img src="../../assets/images/no-data.png" style="width: 300px; display: block; margin: 40px auto" alt="" />
                <p style="text-align: center; color: #999">暂无代购订单，去面料库发起代购吧</p>
            </template>
        </div>

        <ProcurementChat ref="ProcurementChat"></ProcurementChat>
        <DaigouPay ref="DaigouPay" @paid="getOrderList"></DaigouPay>
    </div>
</template>
<script>
import { GetDesignDaigouOrderList, CancelDesignDaigouOrder } from "@/api/daigou";
import { GetProcurementChatUnread } from "@/api/procurement.js";
import ProcurementChat from "@/views/Procurement/components/ProcurementChat.vue";
import DaigouPay from "./components/DaigouPay.vue";
import { Modal } from "iview";

export default {
    name: "DaigouOrderList",
    components: { ProcurementChat, DaigouPay },
    props: {
        // 关键词由外层面料库顶部搜索框统一管理
        keyword: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            size: 10,
            page: 1,
            total: 0,
            unreadMap: {},
            form_data: {
                keyword: "",
                status: "all",
            },
            status_list: [
                { key: "all", name: "全部" },
                { key: "0", name: "待确认金额" },
                { key: "1", name: "待支付" },
                { key: "2", name: "已发货" },
                { key: "3", name: "已收货" },
            ],
            order_list: [],
        };
    },
    watch: {
        "form_data.status"() {
            this.page = 1;
            this.getOrderList();
        },
    },
    mounted() {
        if (this.keyword) {
            this.form_data.keyword = this.keyword;
        }
        this.getOrderList();
        this.getUnread();
        this.$EventBus.$on("procurement-message", this.getUnread);
        this.$EventBus.$on("procurement-unread-refresh", this.getUnread);
    },
    beforeDestroy() {
        this.$EventBus.$off("procurement-message", this.getUnread);
        this.$EventBus.$off("procurement-unread-refresh", this.getUnread);
    },
    methods: {
        change_status(s) {
            this.form_data.status = s;
        },
        // 从订单 materials[0].color_list 中取出各颜色的代购数量（仅展示有数量的颜色）
        colorDetail(v) {
            const materials = v.materials || [];
            const colorList = (materials[0] && materials[0].color_list) || [];
            return colorList.filter((c) => Number(c.send) > 0);
        },
        // 供外层面料库顶部搜索框调用
        doSearch(keyword) {
            this.form_data.keyword = keyword === undefined ? this.form_data.keyword : keyword;
            this.page = 1;
            this.getOrderList();
        },
        changePage(page) {
            this.page = page;
            this.getOrderList();
        },
        changeSize(size) {
            this.page = 1;
            this.size = size;
            this.getOrderList();
        },
        async getOrderList() {
            try {
                const { data } = await GetDesignDaigouOrderList({
                    ...this.form_data,
                    page: this.page,
                    limit: this.size,
                });
                this.order_list = data.list || [];
                this.total = data.count || 0;
            } catch (e) {
                console.log("err-daigou-list", e);
            }
        },
        async getUnread() {
            try {
                const { data } = await GetProcurementChatUnread({ biz_type: "design_daigou" });
                this.unreadMap = data || {};
            } catch (e) {
                // ignore
            }
        },
        showChat(v) {
            this.$refs.ProcurementChat.open(v.uuid, {
                order_no: v.order_no,
                bizType: "design_daigou",
            });
        },
        onPay(v) {
            this.$refs.DaigouPay.open(v);
        },
        onCancel(v) {
            Modal.confirm({
                title: "提示",
                content: "确认取消该代购订单？",
                onOk: async () => {
                    try {
                        const { code, msg } = await CancelDesignDaigouOrder({ uuid: v.uuid });
                        if (code > 0) {
                            this.$layer.msg(msg);
                            return;
                        }
                        this.$layer.msg("已取消");
                        this.getOrderList();
                    } catch (e) {
                        this.$layer.msg(e.msg || "取消失败");
                    }
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.daigou-order-list {
    width: 100%;
    .container {
        padding: 0 0 40px;
        background: #fff;
        min-height: 320px;
        .status-list {
            // 与「历史记录」tab 样式保持一致
            display: flex;
            align-items: center;
            gap: 20px;
            margin-top: 13px;
            .status-item {
                color: #4d4d4d;
                font-size: 14px;
                padding: 9px 16px;
                cursor: pointer;
                &.active {
                    color: #fb486d;
                    font-weight: bold;
                    border-radius: 24px;
                    background: rgba(251, 72, 109, 0.1);
                }
            }
        }
        .list {
            .th {
                display: flex;
                line-height: 46px;
                background: #f6f7fa;
                border-radius: 5px 5px 0 0;
                border: 1px solid #e3e3e3;
                text-align: center;
                color: #575859;
                font-size: 14px;
                .info { width: 420px; }
                .qty { width: 160px; }
                .price { width: 160px; }
                .status { width: 160px; }
                .action { flex: 1; }
            }
            .item {
                border: 1px solid #e3e3e3;
                border-top: none;
                background: #fff;
                .title-row {
                    display: flex;
                    align-items: center;
                    height: 44px;
                    padding: 0 16px;
                    background: #f6f7fa;
                    color: #333;
                    font-size: 13px;
                    .create-time {
                        margin-left: 16px;
                        color: #999;
                    }
                    .chat-entry {
                        margin-left: auto;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        color: #666;
                        cursor: pointer;
                        position: relative;
                        .unread-badge {
                            position: absolute;
                            top: -6px;
                            left: 22px;
                            min-width: 16px;
                            height: 16px;
                            line-height: 16px;
                            padding: 0 4px;
                            background: #ff4d4f;
                            color: #fff;
                            font-size: 11px;
                            border-radius: 8px;
                            text-align: center;
                        }
                    }
                }
                .content {
                    display: flex;
                    align-items: center;
                    text-align: center;
                    padding: 14px 0;
                    .info {
                        width: 420px;
                        display: flex;
                        align-items: center;
                        padding: 0 16px;
                        text-align: left;
                        .image {
                            width: 72px;
                            height: 72px;
                            border-radius: 8px;
                            object-fit: cover;
                        }
                        .info-text {
                            margin-left: 14px;
                            .name {
                                font-size: 14px;
                                font-weight: bold;
                                color: #333;
                            }
                            .code, .type {
                                font-size: 13px;
                                color: #666;
                                margin-top: 6px;
                            }
                        }
                    }
                    .qty {
                        width: 160px;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        .detail-link {
                            color: #0d99ff;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                    .price {
                        width: 160px;
                        font-size: 14px;
                        color: #ff5000;
                        font-weight: bold;
                    }
                    .status {
                        width: 160px;
                        font-size: 14px;
                        &.status-0 { color: #999; }
                        &.status-1 { color: #ff5000; }
                        &.status-2, &.status-3 { color: #02c160; }
                    }
                    .action {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                        .btn {
                            width: 110px;
                            height: 30px;
                            line-height: 30px;
                            border-radius: 4px;
                            font-size: 14px;
                            cursor: pointer;
                            &.btn-pay {
                                background: #fa3d5a;
                                color: #fff;
                            }
                            &.btn-cancel {
                                border: 1px solid #e3e3e3;
                                color: #666;
                            }
                        }
                        .btn-text {
                            color: #666;
                            font-size: 13px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .color-table {
        border-collapse: collapse;
        min-width: 220px;
        th, td {
            border: 1px solid #e3e3e3;
            padding: 6px 12px;
            font-size: 13px;
            text-align: center;
            color: #333;
        }
        thead th {
            background: #f6f7fa;
            color: #666;
            font-weight: normal;
        }
        .c-name {
            display: flex;
            align-items: center;
            gap: 8px;
            text-align: left;
        }
        .c-img {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid #e3e3e3;
            object-fit: cover;
        }
    }
}
</style>
